//@ts-nocheck
import React, { Component } from "react";
import { PlaidLink } from "react-plaid-link";
import packageJson from "../../../../../package.json";
import { get, post } from "../../../../requests";
import MDButton from "../../../../components/MDButton";
import MDBox from "../../../../components/MDBox";
import { usePlaidLink } from "react-plaid-link";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Autocomplete,
  Typography,
  TextField,
} from "@mui/material";

interface PlaidPageProps {
  publicToken: string;
  loadBanksFromServer: () => void;
  setAlert: (message: string) => void;
  setSuccessAlert: (message: string) => void;
  setBank: (bank: any) => void;
  handleAccountRefresh: (bank: any) => void;
  merchantId?: string;
  dealApplicationId?: string;
  plaidBanks?: any[];
  plaidApiError?: { accountId: string; message: string; entityType: string };
  setPlaidApiError?: (
    error: { accountId: string; message: string; entityType: string } | null
  ) => void;
  setShowLoginRequiredModal?: (val: boolean) => void;
  triggerPlaidUpdateLink?: (accountId: string) => void;
  pendingAccountId: null;
}

interface PlaidPageState {
  tenant: string;
  showContactModal: boolean;
  contactOptions: any[];
  selectedContact: any;
  isLoadingContacts: boolean;
  partyId?: string;
  showDirectPlaid: boolean;
  funderLinkToken: string | null;
  selectedBank?: any;
}

interface PlaidResponseMetadata {
  public_token: string;
  institution: {
    name: string;
    institution_id: string;
  };
}

interface PlaidResponse {
  itemId: string;
  accessToken: string;
}

class PlaidComponent extends Component<PlaidPageProps, PlaidPageState> {
  constructor(props: PlaidPageProps) {
    super(props);
    this.handleOnSuccess = this.handleOnSuccess.bind(this);
    this.handleOnExit = this.handleOnExit.bind(this);
    this.handleOnEvent = this.handleOnEvent.bind(this);
    this.state = {
      tenant: "",
      showContactModal: false,
      contactOptions: [],
      selectedContact: null,
      isLoadingContacts: false,
      showDirectPlaid: true,
      funderLinkToken: null,
    };
  }

  sendPlaidResponse = (
    eventType: string,
    eventName: string,
    error: any,
    metadata: PlaidResponseMetadata
  ) => {
    post("sendPlaidResponseEmail", {
      subject: `Plaid Add Bank Log: On ${eventType}`,
      eventName: eventName,
      metaData: metadata,
      error: error,
    });
  };

  componentDidMount() {
    let tenant = localStorage.getItem("currentTenant");
    if (tenant) {
      tenant = tenant.replace("_", " ").toUpperCase();
    } else {
      tenant = "";
    }
    this.setState({ tenant: tenant });
    this.fetchPartyId();
  }

  async componentDidUpdate(prevProps: PlaidPageProps) {
    if (this.props.plaidApiError && this.props.plaidApiError !== prevProps.plaidApiError) {
      console.log("Received new Plaid API error:", this.props.plaidApiError);
      const errorMessage = this.props.plaidApiError.message;
      const needsLogin = errorMessage.includes("ITEM_LOGIN_REQUIRED");

      if (needsLogin) {
        const accountId = this.props.plaidApiError.accountId;
        console.log("Plaid login error detected for account:", accountId);

        try {
          const res = await get(`plaidService/fetchExistingAccessToken/${accountId}`);
          console.log("fetchExistingAccessToken response:", res);

          if (res.status === "Success") {
            const { accessToken, entityType, username, email, userId } = res.data;
            const payload = {
              accessToken,
              dealApplicationId: Number(this.props.dealApplicationId),
              partyId: this.state.partyId,
              tenantId: Number(localStorage.getItem("tenantId")),
              entityType: entityType,
              currentTenant: localStorage.getItem("currentTenant"),
              selectedEmail: email,
              userName: username,
              userId: userId,
            };

            const linkRes = await this.createLinkToken(payload);
            // const linkRes = await post("/plaidService/create/linkToken", payload);
            console.log("linkToken response (update mode):", linkRes);
            const { link_token, hosted_link_url } = linkRes;
            if (entityType?.toUpperCase() === "FUNDER") {
              if (!link_token) {
                throw new Error("No link_token received from backend");
              }

              const handler = (window as any).Plaid.create({
                token: link_token,
                onSuccess: (public_token: string, metadata: any) => {
                  console.log("Plaid update success:", public_token, metadata);
                  this.handleUpdateSuccess(public_token, metadata);
                },
                onExit: (err: any, metadata: any) => {
                  console.log("Plaid update exited:", err, metadata);
                  if (this.props.setShowLoginRequiredModal) {
                    this.props.setShowLoginRequiredModal(false);
                  }
                },
                onEvent: (eventName: string, metadata: any) => {
                  console.log("Plaid update event:", eventName, metadata);
                },
              });
              handler.open();
            } else if (entityType?.toUpperCase() === "MERCHANT") {
              if (!hosted_link_url) {
                throw new Error("No hosted_link_url received from backend for merchant flow");
              }
              try {
                const emailPayload = {
                  recipient: email,
                  userName: username,
                  linkToken: link_token,
                  hostedLink: hosted_link_url,
                  currentTenant: localStorage.getItem("currentTenant"),
                };
                await this.sendPlaidLinkEmail(emailPayload);
                // await post("/plaidService/sendPlaidLinkEmail", emailPayload);
                console.log("Merchant Plaid link sent via email");
                if (this.props.setSuccessAlert) {
                  this.props.setSuccessAlert(
                    `Sign-in link has been successfully sent to ${email} to update new credentials.`
                  );
                }
              } catch (err) {
                console.error("Error sending Plaid link email:", err);
                if (this.props.setErrorAlert) {
                  this.props.setErrorAlert("Failed to send sign-in link email. Please try again.");
                }
              }
            }
          }
        } catch (err: any) {
          console.error("Error during update link flow:", err);
          if (this.props.setErrorAlert) {
            this.props.setErrorAlert("Unexpected error occurred during update link flow.");
          }
        }
      }
    }
  }

  handleUpdateSuccess = async (public_token: string, metadata: any) => {
    try {
      const tokenParams = {
        publicToken: public_token,
        tenantId: localStorage.getItem("tenantId"),
      };

      const tokenResponse = await post("plaidService/getAccessToken", tokenParams);
      console.log("Access token exchange response:", tokenResponse);

      if (tokenResponse.accessToken) {
        if (this.props.loadBanksFromServer) {
          this.props.loadBanksFromServer(this.props.merchantId);
        }
        if (this.props.setSuccessAlert) {
          this.props.setSuccessAlert("Bank login updated successfully");
        }
        if (this.props.setShowLoginRequiredModal) {
          this.props.setShowLoginRequiredModal(false);
        }
      }
    } catch (error) {
      console.error("Error handling update success:", error);
      if (this.props.setAlert) {
        this.props.setAlert("Failed to complete bank login update");
      }
    }
  };

  handleOpenContactModal = () => {
    this.setState({ showContactModal: true });
    this.fetchContacts();
  };

  handleCloseContactModal = () => {
    this.setState({ showContactModal: false });
  };

  fetchContacts = () => {
    const { dealApplicationId } = this.props;
    if (!dealApplicationId) return;

    this.setState({ isLoadingContacts: true });
    get(`deal/getContacts/${dealApplicationId}`)
      .then((response) => {
        console.log("API response:", response);
        const options = response.map((contact) => ({
          label: `${contact.firstName} ${contact.lastName} (${
            contact.email || "no email available"
          })`,
          value: contact.id,
          email: contact.email,
          originalData: contact,
        }));
        console.log("Mapped options:", options);
        this.setState({
          contactOptions: options,
          isLoadingContacts: false,
        });
      })
      .catch((error) => {
        console.error("Error fetching contacts:", error);
        this.setState({ isLoadingContacts: false });
      });
  };

  fetchPartyId = async () => {
    const { dealApplicationId } = this.props;
    if (!dealApplicationId) return;

    this.setState({ isLoadingContacts: true });

    try {
      const response = await get(`getDealApplication/${dealApplicationId}`);
      if (response && response.partyId) {
        this.setState({ partyId: response.partyId });
      }
    } catch (error) {
      console.error("Error fetching application details:", error);
    } finally {
      this.setState({ isLoadingContacts: false });
    }
  };

  createLinkToken = async (payload: any) => {
    try {
      const response = await post("/plaidService/create/linkToken", payload);
      if (!response?.link_token && !response?.hosted_link_url) {
        throw new Error("No link token or hosted link url returned from backend");
      }
      return response;
    } catch (error: any) {
      console.error("Error creating Plaid link token:", error);
      const errorMsg = error.response?.data?.error || "Failed to generate Plaid link";
      if (this.props.setAlert) {
        this.props.setAlert(errorMsg);
      }
      throw error;
    }
  };

  sendPlaidLinkEmail = async (emailPayload: any) => {
    try {
      await post("/plaidService/sendPlaidLinkEmail", emailPayload);
      if (this.props.setSuccessAlert) {
        this.props.setSuccessAlert(
          `Plaid sign-in link has been successfully sent to ${emailPayload.recipient}`
        );
      }
      return true;
    } catch (error: any) {
      console.error("Error sending Plaid link email:", error);
      const errorMsg = error.response?.data?.error || "Failed to send sign-in link email.";
      if (this.props.setAlert) {
        this.props.setAlert(errorMsg);
      }
      return false;
    }
  };

  handleSubmitContact = () => {
    const { selectedContact, partyId } = this.state;
    if (!selectedContact || !selectedContact.email) {
      this.props.setAlert("Selected contact has no email address");
      return;
    }

    const contactData = selectedContact.originalData;
    const payload = {
      dealApplicationId: Number(this.props.dealApplicationId),
      partyId: partyId,
      userId: Number(selectedContact.value),
      tenantId: Number(localStorage.getItem("tenantId")),
      selectedEmail: selectedContact.email,
      userFirstName: contactData.firstName,
      userName: `${contactData.firstName} ${contactData.lastName}`,
      currentTenant: localStorage.getItem("currentTenant"),
      entityType: "merchant",
    };

    // post("/plaidService/create/linkToken", payload)
    this.createLinkToken(payload)
      .then(({ link_token, hosted_link_url }) => {
        const emailPayload = {
          recipient: selectedContact.email,
          userName: `${contactData.firstName} ${contactData.lastName}`,
          linkToken: link_token,
          hostedLink: hosted_link_url,
          currentTenant: localStorage.getItem("currentTenant"),
        };
        // return post("/plaidService/sendPlaidLinkEmail", emailPayload);
        return this.sendPlaidLinkEmail(emailPayload);
      })
      .then(() => {
        this.props.setSuccessAlert("Plaid link sent successfully to " + selectedContact.email);
        this.handleCloseContactModal();
      })
      .catch((error) => {
        const errorMsg = error.response?.data?.error || "Failed to generate Plaid link";
        this.props.setAlert(errorMsg);
      });
  };

  handleManualLogin = async () => {
    this.handleCloseContactModal();
    const { partyId } = this.state;
    if (!partyId) return;

    const payload = {
      dealApplicationId: Number(this.props.dealApplicationId),
      partyId: partyId,
      tenantId: Number(localStorage.getItem("tenantId")),
      entityType: "funder",
      currentTenant: localStorage.getItem("currentTenant"),
    };

    try {
      const { link_token } = await this.createLinkToken(payload);
      // const response = await post("/plaidService/create/linkToken", payload);
      // const { link_token } = response;
      if (!link_token) throw new Error("No link_token returned");

      const handler = (window as any).Plaid.create({
        token: link_token,
        onSuccess: (public_token: string, metadata: any) => {
          console.log("Plaid success:", public_token, metadata);
          let tenantId = localStorage.getItem("tenantId");
          this.getAccessToken({ publicToken: public_token, tenantId }, tenantId, metadata);
          this.sendPlaidResponse("Success", "", {}, metadata);
        },
        onExit: (err: any, metadata: any) => {
          console.log("Plaid exited:", err, metadata);
          this.sendPlaidResponse("Exit", "", err, metadata);
        },
        onEvent: (eventName: string, metadata: any) => {
          console.log("Plaid event:", eventName, metadata);
          this.sendPlaidResponse("Event", eventName, {}, metadata);
        },
      });

      handler.open();
    } catch (error) {
      const errorMsg = error.response?.data?.error || "Failed to generate Plaid link";
      this.props.setAlert(errorMsg);
    }
  };
  handleOnSuccess(token: string, metadata: PlaidResponseMetadata) {
    let publicToken = metadata.public_token;
    let tenantId = localStorage.getItem("tenantId");
    let params = { publicToken, tenantId };
    this.getAccessToken(params, tenantId, metadata);
    this.sendPlaidResponse("Success", "", {}, metadata);
    this.setState({ showDirectPlaid: false });
  }

  getAccessToken = (params: any, tenantId: string | null, metadata: PlaidResponseMetadata) => {
    post("plaidService/getAccessToken", params).then((responseData: PlaidResponse) => {
      let bank = {
        isMerchantBank: !!this.props.merchantId,
        partyId: this.props.merchantId,
        itemId: responseData.itemId,
        accessToken: responseData.accessToken,
        status: "Active",
        name: metadata.institution.name,
        institutionId: metadata.institution.institution_id,
        tenantId: tenantId,
        dealApplicationId: Number(this.props.dealApplicationId),
      };
      post("createOrUpdateBank", bank).then((result: any) => {
        if (result.isBankPresent) {
          this.props.loadBanksFromServer(this.props.merchantId);
          this.props.setSuccessAlert("Bank updated.");
        } else {
          this.props.setBank(result);
          this.props.handleAccountRefresh(result);
        }
      });
    });
  };

  handleOnExit(error: any, metadata: any) {
    console.log("link: user exited");
    console.log(error, metadata);
    this.props.loadBanksFromServer(this.props.merchantId);
    this.sendPlaidResponse("Exit", "", error, metadata);
    this.setState({ showDirectPlaid: false });
  }

  handleOnLoad() {
    console.log("link: loaded");
  }

  handleOnEvent(eventname: string, metadata: any) {
    console.log("link: user event", eventname, metadata);
    this.sendPlaidResponse("Event", eventname, {}, metadata);
  }

  render() {
    const {
      showContactModal,
      contactOptions,
      selectedContact,
      isLoadingContacts,
      showDirectPlaid,
    } = this.state;

    const plaidMode = localStorage.getItem("plaidMode");
    const plaidPublicKey = localStorage.getItem("plaidPublicKey");

    return (
      <>
        <div style={{ display: "none" }}>
          <PlaidLink
            clientName={this.state.tenant}
            env={plaidMode}
            token={this.state.funderLinkToken}
            product={["auth", "transactions"]}
            publicKey={plaidPublicKey}
            onSuccess={this.handleOnSuccess}
            onExit={this.handleOnExit}
            onEvent={this.handleOnEvent}
            onLoad={this.handleOnLoad}
          >
            <button className="direct-plaid-button">Connect Bank Account</button>
          </PlaidLink>
        </div>

        <MDButton variant="gradient" color="primary" onClick={this.handleOpenContactModal}>
          Login with Plaid
        </MDButton>

        <Dialog
          open={showContactModal}
          onClose={this.handleCloseContactModal}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>INITIATE PLAID</DialogTitle>

          <DialogContent>
            <MDBox marginTop={3} marginBottom={4}>
              <Autocomplete
                options={this.state.contactOptions.map((opt) => opt.originalData)}
                getOptionLabel={(option) =>
                  `${option.firstName} ${option.lastName} (${option.email || "No Email Available"})`
                }
                value={this.state.selectedContact?.originalData || null}
                onChange={(event, newValue) => {
                  const selected = this.state.contactOptions.find(
                    (opt) => opt.originalData.id === newValue?.id
                  );
                  this.setState({ selectedContact: selected });
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Select Contact" variant="outlined" required />
                )}
                isOptionEqualToValue={(option, value) => option.id === value?.id}
                loading={this.state.isLoadingContacts}
              />
            </MDBox>

            <MDBox display="flex" flexDirection={"column"} mb={1} gap={1}>
              <Typography variant="h1" sx={{ fontSize: 14 }}>
                INSTRUCTIONS
              </Typography>
              <Typography sx={{ fontSize: 14 }}>
                Select a merchant contact to send the Plaid link via email. The merchant will
                receive instructions to securely connect their bank account.
              </Typography>
            </MDBox>
          </DialogContent>

          <DialogActions>
            <MDButton variant="contained" color="error" onClick={this.handleCloseContactModal}>
              Cancel
            </MDButton>

            <MDButton
              variant="contained"
              color="primary"
              onClick={this.handleSubmitContact}
              disabled={!this.state.selectedContact || !this.state.selectedContact.email}
            >
              Send Link
            </MDButton>

            <MDButton color="info" onClick={this.handleManualLogin}>
              Manual Login
            </MDButton>
          </DialogActions>
        </Dialog>
      </>
    );
  }
}

export default PlaidComponent;
